<template>
  <v-dialog
    v-model="active"
    width="80%"
    persistent
  >
    <v-card
      color="primary"
      class="rounded-sm"
    >
      <v-card-title>
        <div class="text-h6">
          Registro de informe en alcance
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="evaluacionIse">
        <v-container>
          <v-form v-model="informeAlcanceForm">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="informeAlcance.numeroOficio"
                  label="Número de oficio"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="required"
                />
              </v-col>
              <v-col cols="4">
                <v-menu
                  v-model="menuFechaInforme"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="computedFechaInformeAlcance"
                      label="Fecha de informe en alcance"
                      prepend-icon="mdi-calendar"
                      readonly
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="informeAlcance.fechaInformeAlcance"
                    @input="menuFechaInforme = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="informeAlcance.fk_idCatDiagnostico"
                  label="Diagnostico"
                  :items="diagnostico"
                  item-color="secondary"
                  item-value="id"
                  item-text="title"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuFechaRespuesta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="computedFechaRespuesta"
                      label="Fecha respuesta"
                      prepend-icon="mdi-calendar"
                      readonly
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="informeAlcance.fechaRespuesta"
                    @input="menuFechaRespuesta = false"
                  />
                </v-menu>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="informeAlcance.respuesta"
                  label="Respuesta"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="required"
                />
              </v-col>
              <v-col>
                <v-select
                  v-model="informeAlcance.fk_idCatEstatusInformeAlcance"
                  label="Estatus"
                  :items="estatusInformeAlcance"
                  item-color="secondary"
                  item-value="id"
                  item-text="title"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="informeAlcance.informacionAdicional"
                  label="Información adicional"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :rules="required"
                  no-resize
                  rows="8"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="secondary"
          :loading="loading"
          :disabled="loading || !informeAlcanceForm"
          @click="triggerSaveInformeAlcance()"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionIse: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      menuFechaInforme: false,
      menuFechaRespuesta: false,
      loading: false,
      informeAlcanceForm: false,

      informeAlcance: {
        idExpediente: null,
        idEvaluacionIse: null,
        fechaInformeAlcance: null,
        numeroOficio: '',
        fk_idCatDiagnostico: null,
        fechaRespuesta: '',
        respuesta: '',
        fk_idCatEstatusInformeAlcance: null,
        informacionAdicional: '',
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('diagnostico', {
      diagnostico: 'getDiagnostico',
    }),
    ...mapGetters('estatusInformeAlcance', {
      estatusInformeAlcance: 'getEstatusInformeAlcance',
    }),

    computedFechaInformeAlcance() {
      return this.informeAlcance.fechaInformeAlcance ? moment(this.informeAlcance.fechaInformeAlcance).format('DD/MM/YYYY') : '';
    },

    computedFechaRespuesta() {
      return this.informeAlcance.fechaRespuesta ? moment(this.informeAlcance.fechaRespuesta).format('DD/MM/YYYY') : '';
    },
  },

  async mounted() {
    await this.fetchEstatusInformeAlcance();
  },

  methods: {
    ...mapActions('estatusInformeAlcance', ['fetchEstatusInformeAlcance']),
    ...mapActions('informeAlcance', ['saveInformeAlcance']),
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    async triggerSaveInformeAlcance() {
      this.loading = true;
      await this.saveInformeAlcance({
        idExpediente: this.evaluacionIse.Derivacion.Programacion.fk_idExpediente,
        idEvaluacionIse: this.evaluacionIse.idIse,
        fechaInformeAlcance: moment(this.informeAlcance.fechaInformeAlcance).format('DD/MM/YYYY'),
        numeroOficio: this.informeAlcance.numeroOficio,
        fk_idCatDiagnostico: this.informeAlcance.fk_idCatDiagnostico,
        fechaRespuesta: moment(this.informeAlcance.fechaRespuesta).format('DD/MM/YYYY'),
        respuesta: this.informeAlcance.respuesta,
        fk_idCatEstatusInformeAlcance: this.informeAlcance.fk_idCatEstatusInformeAlcance,
        informacionAdicional: this.informeAlcance.informacionAdicional,
      });

      await this.updateEstatusDerivacion({
        fk_idProgramacion: this.evaluacionIse.Derivacion.fk_idProgramacion,
        idDerivacion: this.evaluacionIse.Derivacion.idDerivacion,
      });

      await this.fetchDerivacionesByArea(this.evaluacionIse.Derivacion.fk_idEquipoApplication);

      this.loading = false;
      this.closeDialog();
    },

    closeDialog() {
      this.loading = false;
      this.$emit('close');
    },
  },
};
</script>
